import React from 'react'

import { MerchantLookupTxSetFieldTypes } from 'types/merchanTxTypes'
import Form from './Form'

const Index: React.FC<{
  isMerchantLookupToggle: boolean
  setFieldValue: MerchantLookupTxSetFieldTypes
  title?: string;
  placeholder?: string;
  useMerchantLookupLists?: boolean;
}> = ({ isMerchantLookupToggle, setFieldValue, title , placeholder, useMerchantLookupLists}): React.ReactElement => {
  if (!isMerchantLookupToggle) return <></>
  return <Form setFieldValue={setFieldValue} title={title} placeholder={placeholder} useMerchantLookupLists={useMerchantLookupLists}/>
}

export default Index
